import {
  AnyAction,
  CombinedState,
  configureStore,
  ThunkDispatch,
} from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';

import { getMiddleware } from './middlewares';
import { RootState, history, rootReducer, createReducer } from './reducers';

const defualtMiddlewareOptions = {
  serializableCheck: {
    ignoredActionPaths: [
      // TODO: Uploads Cleanup EPD-1426
      //       uploaderInstance and file can be removed here
      'args.uploaderInstance',
      'args.file',
      'queryParams',
    ],
    ignoredActions: [],
  },
};

// Setup store with basic root reducer for type safety
export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware(defualtMiddlewareOptions).concat(
      getMiddleware(history)
    ),
  devTools: process.env.NODE_ENV !== 'production',
});

let asyncReducers = {};

// This is how lazy-loaded packages can add their stores once loaded
export const injectReducers = function (reducerMap): void {
  asyncReducers = {
    ...asyncReducers,
    ...reducerMap,
  };
  store.replaceReducer(createReducer(asyncReducers));
};

export type AppDispatch = typeof store.dispatch;

// Use throughout your app instead `useDispatch`  for better type inference
export const useAppDispatch = (): ThunkDispatch<
  CombinedState<RootState>,
  undefined,
  AnyAction
> => useDispatch<AppDispatch>();

// Use throught your app instead of useDispatch for better type inference
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export type { RootState };

export { history };

export default store;
